import styled from "styled-components/macro";

const PlanCardUpPartStyled = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
  cursor: ${({ clickable }) => clickable ? 'pointer' : 'default'};
`;

export default PlanCardUpPartStyled;
